import React from 'react'
import { Box } from '@mui/material'
import ReadOnlyNotice from 'modules/Admin/ReadOnlyNotice'
import AccountHeader from '../AccountHeader'
import { useIsMobile } from 'utils/UI'

const AccountPage = ({ children, title }) => {
  const isMobile = useIsMobile()
  return (
    <main
      style={{
        marginLeft: isMobile ? 0 : 300,
        minHeight: '90vh',
      }}
    >
      <AccountHeader title={title} />
      <Box sx={{ px: { xs: 2, md: 3 } }}><ReadOnlyNotice /></Box>
      {children}
    </main>
  )
}

export default AccountPage
